import singleSpaVue from "single-spa-vue";
import Vue from 'vue';
import App from './modules/App';
import router from './router';
import '@components';
import './layouts';
import {checkLoggedSession} from "@helpers/api-helper";
import {setActivePinia} from 'pinia';

await import('./bootstrap');

const containerSelector = '#app';
let vueLifecycles;

export const bootstrap = async props => {
    let pinia = props?.boot?.pinia;
    setActivePinia(pinia);

    vueLifecycles = singleSpaVue({
        Vue,
        appOptions: {
            render: h => h(App),
            el: containerSelector,
            pinia,
            router,
        }
    });

    let boot = await vueLifecycles.bootstrap(props);

    return Promise.resolve(boot);
};
export const mount = async (props) => {

    //do the user session check here & set required axios headers
    await checkLoggedSession(false, false);

    return vueLifecycles.mount(props)
};
export const unmount = (props) => vueLifecycles.unmount(props);